import React from 'react'

import { useFreeSpinsBonusesStore } from '@stores'

import { DeclineButtonsTemplate } from '@components/BonusSystemCommon'
import { FreeSpinsBonus } from '@amusnet/mgs-ws-client'

interface FSDeclineButtonsProps {
    bonus?: FreeSpinsBonus
}

const FSDeclineButtons: React.FC<FSDeclineButtonsProps> = ({ bonus }: FSDeclineButtonsProps) => {
    const bonusSystemDeclineState = useFreeSpinsBonusesStore((state) => state.bonusSystemDeclineState)
    const setBonusSystemState = useFreeSpinsBonusesStore((state) => state.setBonusSystemState)
    const setBonusSystemDeclineState = useFreeSpinsBonusesStore((state) => state.setBonusSystemDeclineState)
    const setDeclinedBonusesIds = useFreeSpinsBonusesStore((state) => state.setDeclinedBonusesIds)

    return (
        <DeclineButtonsTemplate
            bonus={bonus}
            bonusSystemDeclineState={bonusSystemDeclineState}
            setBonusSystemState={setBonusSystemState}
            setBonusSystemDeclineState={setBonusSystemDeclineState}
            setDeclinedBonusesIds={setDeclinedBonusesIds}
        />
    )
}

export default FSDeclineButtons
